document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.beardo-stores-gallery__track').forEach((track) => {
    const firstSet = track.querySelector('.beardo-stores-gallery__set');
    if (!firstSet) return;

    const setWidth = firstSet.offsetWidth;
    if (setWidth === 0) return;

    const minFill = window.innerWidth * 2 + setWidth;
    const setsNeeded = Math.ceil(minFill / setWidth);

    for (let i = 1; i < setsNeeded; i++) {
      const clone = firstSet.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    track.style.setProperty('--stores-gallery-track-width', `${setWidth}px`);
  });
});
